import { render, staticRenderFns } from "./MobileMessageBanner.vue?vue&type=template&id=67fe0f1e&scoped=true"
import script from "./MobileMessageBanner.vue?vue&type=script&lang=js"
export * from "./MobileMessageBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileMessageBanner.vue?vue&type=style&index=0&id=67fe0f1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe0f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fe0f1e')) {
      api.createRecord('67fe0f1e', component.options)
    } else {
      api.reload('67fe0f1e', component.options)
    }
    module.hot.accept("./MobileMessageBanner.vue?vue&type=template&id=67fe0f1e&scoped=true", function () {
      api.rerender('67fe0f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/MobileMessageBanner.vue"
export default component.exports